module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#cinema",
      toString: function () {
        return this.url;
      }
    }